import { render, staticRenderFns } from "./additionalInfo.vue?vue&type=template&id=3c9a1b6d&scoped=true"
import script from "./additionalInfo.vue?vue&type=script&lang=js"
export * from "./additionalInfo.vue?vue&type=script&lang=js"
import style0 from "./additionalInfo.vue?vue&type=style&index=0&id=3c9a1b6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9a1b6d",
  null
  
)

export default component.exports